module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'logistic-map' && templateVars.config ?
				templateVars.config :
				{
	"ru": {
		"layers": {
			"zoomx1": {
				"map": "/images/components/logistic-map/images/layers/ru/0.jpg",
				"filter1": "/images/components/logistic-map/images/layers/ru/1.jpg",
				"filter2": "/images/components/logistic-map/images/layers/ru/2.jpg",
				"filter3": "/images/components/logistic-map/images/layers/ru/3.jpg"
			},
			"zoomx2": {
				"map": "/images/components/logistic-map/images/layers/ru/+0.jpg",
				"filter1": "/images/components/logistic-map/images/layers/ru/+1.jpg",
				"filter2": "/images/components/logistic-map/images/layers/ru/+2.jpg",
				"filter3": "/images/components/logistic-map/images/layers/ru/+3.jpg"
			}
		},
		"changeMapAnimationSpeed": 100
	},
	"en": {
		"layers": {
			"zoomx1": {
				"map": "/images/components/logistic-map/images/layers/en/0.jpg",
				"filter1": "/images/components/logistic-map/images/layers/en/1.jpg",
				"filter2": "/images/components/logistic-map/images/layers/en/2.jpg",
				"filter3": "/images/components/logistic-map/images/layers/en/3.jpg"
			},
			"zoomx2": {
				"map": "/images/components/logistic-map/images/layers/en/+0.jpg",
				"filter1": "/images/components/logistic-map/images/layers/en/+1.jpg",
				"filter2": "/images/components/logistic-map/images/layers/en/+2.jpg",
				"filter3": "/images/components/logistic-map/images/layers/en/+3.jpg"
			}
		},
		"changeMapAnimationSpeed": 100
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/logistic-map/config.yaml
// module id = 52
// module chunks = 0